import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { TaskErrorsServiceSingleton } from '.';

export const useTaskErrors = (variables: Record<string, string>) => {
  const { formState } = useFormContext();

  useEffect(() => {
    TaskErrorsServiceSingleton.processTaskErrors(formState.errors, variables);
  }, [formState, variables]);
};
